<template>
  <div class="widget-pagination">
    <div>
      <z-link
        v-if="haveLeftContent"
        :href="pagination.previousPage[1]"
        size="medium"
        tag="a"
      >
        <z-icon
          :icon="['fas', 'chevron-left']"
          size="medium"
        />

        {{ pagination.previousPage[0] }}
      </z-link>
    </div>

    <div>
      <z-link
        v-if="haveRightContent"
        :href="pagination.forwardPage[1]"
        size="medium"
        tag="a"
      >
        {{ pagination.forwardPage[0] }}

        <z-icon
          :icon="['fas', 'chevron-right']"
          size="medium"
        />
      </z-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetPagination',

  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },

  computed: {
    haveLeftContent () {
      return this.pagination.previousPage[0] && this.pagination.previousPage[1]
    },
    haveRightContent () {
      return this.pagination.forwardPage[0] && this.pagination.forwardPage[1]
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-pagination {
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  min-height: var(--unit-0600);
  width: 100%;
}
</style>
